// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3ZEcQ","logo":"Header_logo__1WaYN"};